/**
 * Utilidad para obtener las clases de estilo de los badges de estatus de pólizas
 * 
 * Mapeo de colores:
 * - Verde: Estados activos/vigentes ("EN VIGOR", "ACTIVA", "ACTIVE")
 * - Rojo: Estados anulados/cancelados ("ANULADA", "CANCELADA", "EXPIRADA")
 * - Amarillo: Estados pendientes ("PENDIENTE", "PENDING")
 * - Gris: Estados por defecto o sin clasificar
 * 
 * @param {string} status - El estatus de la póliza
 * @returns {string} - Clases de Tailwind CSS para el badge
 */
export const getStatusBadgeClasses = (status) => {
  if (!status) return 'bg-slate-100 text-slate-700 border border-slate-200';
  
  const statusLower = status.toLowerCase().trim();
  
  // 🟢 Verde - Estados activos/vigentes
  if (statusLower.includes('vigor') || statusLower.includes('active') || statusLower.includes('activa')) {
    return 'bg-emerald-100 text-emerald-700 border border-emerald-200';
  }
  
  // 🔴 Rojo - Estados anulados/cancelados/expirados
  if (statusLower.includes('anulada') || statusLower.includes('cancelled') || 
      statusLower.includes('cancelada') || statusLower.includes('expired') || 
      statusLower.includes('expirada')) {
    return 'bg-red-100 text-red-700 border border-red-200';
  }
  
  // 🟡 Amarillo - Estados pendientes
  if (statusLower.includes('pending') || statusLower.includes('pendiente')) {
    return 'bg-amber-100 text-amber-700 border border-amber-200';
  }
  
  // ⚪ Gris - Por defecto
  return 'bg-slate-100 text-slate-700 border border-slate-200';
};

/**
 * Obtiene un emoji representativo del estatus (opcional)
 * 
 * @param {string} status - El estatus de la póliza
 * @returns {string} - Emoji correspondiente
 */
export const getStatusEmoji = (status) => {
  if (!status) return '⚪';
  
  const statusLower = status.toLowerCase().trim();
  
  if (statusLower.includes('vigor') || statusLower.includes('active') || statusLower.includes('activa')) {
    return '✅';
  }
  
  if (statusLower.includes('anulada') || statusLower.includes('cancelled') || 
      statusLower.includes('cancelada') || statusLower.includes('expired') || 
      statusLower.includes('expirada')) {
    return '❌';
  }
  
  if (statusLower.includes('pending') || statusLower.includes('pendiente')) {
    return '⏳';
  }
  
  return '⚪';
};
